module.exports = __webpack_public_path__ + "img/z-adimg5-2.7612555c.png";